export interface Testimonial {
  name: string
  location: string
  flag: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Valentina R.',
    location: 'Buenos Aires',
    flag: '🇦🇷',
    quote:
      'Jamás pensé que iba a encontrar algo tan completo. Tengo todo el año planificado con actividades que a mis alumnos les encantan. Me cambió la vida como docente.',
  },
  {
    name: 'Rodrigo M.',
    location: 'Córdoba',
    flag: '🇦🇷',
    quote:
      'Los proyectos de Arte Digital del Tomo 6 hicieron que mis alumnos de último año se entusiasmaran como nunca. Vale cada peso.',
  },
  {
    name: 'Camila G.',
    location: 'Rosario',
    flag: '🇦🇷',
    quote:
      'Las evaluaciones y rúbricas me ahorraron horas de trabajo. Parece hecho a medida para el sistema educativo argentino.',
  },
  {
    name: 'Martina L.',
    location: 'Mendoza',
    flag: '🇦🇷',
    quote:
      'Por este precio es un regalo. Solo las rúbricas ya valen el doble. Muy recomendado para cualquier profe de Arte.',
  },
  {
    name: 'Lucía P.',
    location: 'La Plata',
    flag: '🇦🇷',
    quote:
      'Mis alumnos notaron el cambio enseguida. Las clases se sienten mucho más profesionales y los chicos vienen con más ganas.',
  },
  {
    name: 'Andrea C.',
    location: 'Tucumán',
    flag: '🇦🇷',
    quote:
      'Empecé a usarlo en primaria y ahora lo uso también en secundaria. La progresión de los tomos es perfecta para el currículum argentino.',
  },
]
